import { ReactComponent as Spin } from './ajax-loader-red.svg';

const AccionaSpinner = () => <Spin height="24" width="24" alt="Loading"></Spin>;

export default AccionaSpinner;
